export default __webpack_public_path__ + "static/media/KSOP_Plan_Brochure.63befcde.pdf";